import * as Icons from "@material-ui/icons";

import { Menu as FobMenu, MenuGroup, MenuItem } from "ra-friendsofbabba";
import React, { Fragment, useMemo } from "react";
import { usePermissions, useQuery, useTranslate } from "react-admin";

const createEvalLink = (group) =>
  `/research-project-evals?filter=${JSON.stringify({
    group,
    view: 1,
  })}&order=DESC&sort=Points.total`;
const createProjectLink = (state) =>
  `/research-projects?filter=${JSON.stringify({
    state,
    view: 1,
  })}`;

const MenuContentGroup = ({
  translate,
  open,
  location,
  onMenuClick,
  menu,
  filter,
}) => {
  const groups = useMemo(() => menu.filter((g) => filter(g)), [menu, filter]);
  return groups.map((group, idx) => (
    <MenuGroup
      key={idx}
      open={open}
      label={translate(`menu.groups.${group.label}`)}
    >
      {group.items.map((item, index) => (
        <MenuItem
          {...item}
          key={index}
          open={open}
          location={location}
          onMenuClick={onMenuClick}
        />
      ))}
    </MenuGroup>
  ));
};
const MenuContent = ({
  menu,
  open,
  location,
  onMenuClick,
  translate,
  isAdmin,
}) => (
  <Fragment>
    <MenuContentGroup
      menu={menu}
      open={open}
      translate={translate}
      location={location}
      onMenuClick={onMenuClick}
      filter={(g) => g.label !== "admin"}
    />
    {isAdmin && (
      <MenuGroup open={open} label={translate("menu.groups.reports")}>
        {["sent", "sent_late", "canceled", "duplicated"].map((state) => (
          <MenuItem
            key={state}
            open={open}
            location={location}
            icon={Icons.AssignmentTurnedIn}
            label={translate(`menu.items.research-projects.${state}`)}
            to={createProjectLink(state)}
          />
        ))}
      </MenuGroup>
    )}
    {isAdmin && (
      <MenuGroup open={open} label={translate("menu.groups.evals")}>
        {["bari", "foggia", "salento", "politecnico", "degennaro", "epr"].map(
          (group) => (
            <MenuItem
              key={group}
              open={open}
              location={location}
              icon={Icons.PlaylistAddCheckOutlined}
              label={translate(`menu.items.${group}`)}
              to={createEvalLink(group)}
            />
          )
        )}
      </MenuGroup>
    )}
    <MenuContentGroup
      menu={menu}
      open={open}
      translate={translate}
      location={location}
      onMenuClick={onMenuClick}
      filter={(g) => g.label === "admin"}
    />
  </Fragment>
);
const Menu = (props) => {
  const translate = useTranslate();
  const { data: pages } = useQuery({
    resource: "pages/menu",
    type: "get",
  });
  const { data: badges } = useQuery({
    resource: "stats/badges",
    type: "get",
  });
  const { permissions } = usePermissions();
  const { isAdmin, isTro } = useMemo(
    () => ({
      isAdmin: permissions && permissions(["admin"]),
      isTro: permissions && permissions(["tro"]),
    }),
    [permissions]
  );

  return (
    <FobMenu
      {...props}
      mode="custom"
      order={{
        dashboard: 10,

        admin: 100,
        pages: 10,
      }}
      items={pages?.data?.map((page) => ({
        name: page.name,
        path: `/pages/${page.id}/show`,
        label: page.name,
        icon: Icons.Info,
        group: "pages",
        localize: false,
      }))}
      badges={badges?.data}
    >
      <MenuContent {...props} translate={translate} isAdmin={isAdmin} />
      <MenuGroup label={translate("menu.groups.contacts")}>
        <MenuItem
          icon={Icons.Email}
          label={translate("menu.items.contact_tech")}
          sub={translate("menu.items.contact_tech.help")}
          href="mailto:assistenza.riparti@regione.puglia.it"
        />
        <MenuItem
          icon={Icons.Info}
          label={translate("menu.items.contact_info")}
          sub={translate("menu.items.contact_info.help")}
          href="mailto:info.riparti@regione.puglia.it"
        />
        <MenuItem
          icon={Icons.Dock}
          label={translate("menu.items.documentation")}
          sub={translate("menu.items.documentation.help")}
          href="https://riparti.regione.puglia.it/wp-content/uploads/2022/08/linee-guida.zip ?"
        />
        {isTro && (
          <MenuItem
            icon={Icons.Help}
            label={translate("menu.items.documentation.user_breaks")}
            sub={translate("menu.items.documentation.user_breaks.help")}
            href="https://riparti.regione.puglia.it/candidatura/assets/guida-utente-dimissioni-maternita.pdf"
          />
        )}
      </MenuGroup>
      <MenuGroup label={translate("menu.groups.schemas")}>
        <MenuItem
          icon={Icons.FileCopySharp}
          label={translate("menu.items.schemas.executive_project")}
          sub={translate("menu.items.schemas.executive_project.help")}
          href="https://riparti.regione.puglia.it/candidatura/assets/schema-progetto-esecutivo-di-ricerca.zip"
        />
      </MenuGroup>
    </FobMenu>
  );
};

export default Menu;
